import { render, staticRenderFns } from "./EmojisRating.vue?vue&type=template&id=357908e6&scoped=true&"
import script from "./EmojisRating.vue?vue&type=script&lang=js&"
export * from "./EmojisRating.vue?vue&type=script&lang=js&"
import style0 from "./EmojisRating.vue?vue&type=style&index=0&id=357908e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357908e6",
  null
  
)

export default component.exports